import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { AuthService } from '../auth.service';

@Component({
	selector: 'kt-cambiar-contrasena',
	templateUrl: './cambiar-contrasena.component.html',
	styleUrls: ['./cambiar-contrasena.component.scss']
})
export class CambiarContrasenaComponent implements OnInit {
	public usuarioForm: FormGroup;
	public user;

	constructor(private dialogRef: MatDialogRef<CambiarContrasenaComponent>, private fb: FormBuilder,
		private toastService: ToastrService,
		private authService: AuthService) { }

	ngOnInit() {
		this.user = this.authService.getUser();
		this.initForm();
	}

	initForm() {
		const pattern = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{6,}$/
		this.usuarioForm = this.fb.group({
			PasswordActual: ['', [
				Validators.required,
				Validators.min(6),
				Validators.max(15),
				Validators.pattern(pattern)]],
			PasswordNuevo: ['', [
				Validators.required,
				Validators.min(6),
				Validators.max(15),
				Validators.pattern(pattern)]],
			ConfirmarPassword: ['', Validators.required]
		});
	} s

	modificarDatos() {
		if (this.usuarioForm.get('PasswordNuevo').value === this.usuarioForm.get('ConfirmarPassword').value) {

			this.authService.changePassword(this.usuarioForm.value).pipe(
				finalize(() => {
					this.dialogRef.close();
					this.toastService.success('Actualización correcta');
				})
			).subscribe(
				(response) => {
				}
			)
		} else {
			this.toastService.error('Las contraseñas no coincieden')
		}
	}

	public minimizarPopup() {
		this.dialogRef.addPanelClass('displayNone');
	}

	public maximizarPopup() {
		this.dialogRef.removePanelClass('displayNone');
	}

	public cerrarPopup() {
		this.dialogRef.close();
	}

}
